import { SHOW_LOADING } from '../types'

export const controlLoading = (value) => ({
    type: SHOW_LOADING,
    payload: value,
})
